<template>
  <el-container class="index-con">
    
    <div class="index-header" style="border-bottom: solid 1px #e6e6e6;">
      <navcon></navcon>
    </div>
    <div class="index-page"></div>
    <div style="padding-top: 40px;">
      <div class="main-con" style="margin-bottom: 40px;">
        <!-- 面包屑导航 -->
        <div class="breadcrumb" style="margin-bottom: 40px;">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/'}">海量数据</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/index/exam'}">{{type==1?'考试中心':'我的报名'}}</el-breadcrumb-item>
            <el-breadcrumb-item>{{type==1?'考试详情':'报名详情'}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <!-- 卡片 -->
        <div class="authentication">
          <img class="product-image" :src="examInfo.examImg">
          <div class="product-card">
            <p class="product-card-name">{{examInfo.examName}}</p>
            <p class="product-card-time"><span style="margin-right:10px">报名时间：{{examInfo.signStartTime.split(' ')[0]}}-{{examInfo.signEndTime.split(' ')[0]}}</span> | <span style="margin-left:10px">考试时间：{{examInfo.examStartTime.split(' ')[0]}}-{{ examInfo.examEndTime.split(' ')[0] }}</span></p>
            <div class="product-card-kv">
              <p class="key">允许作答次数：<span>{{examInfo.examCount}}次</span></p>
              <p class="key">考试时长：<span>{{examInfo.examDuration}}分钟</span></p>
              <p class="key" style="width: auto;">考试形式：<span>{{examInfo.examForm==1?'线上':'线下'}}</span></p>
              <p class="key" style="width: 100%;">适合群体：<span>{{examInfo.suitGroup}}</span></p>
            </div>
            <div class="product-card-coupon" v-if="type==1">
              <div class="product-card-coupon-item" :class="item.hasFlag==1?'popup-coupon-cur':''" v-for="item,index in examInfo.couponsList" :key="index" v-if="index<2">
                <p class="product-card-coupon-item-discount">{{item.discountRatio *10}}<span>折</span></p>
                <div class="product-card-coupon-item-content">
                  <p class="product-card-coupon-item-content-name">{{item.couponName}}</p>
                  <p class="product-card-coupon-item-content-time">{{item.createTime.split(' ')[0]}}</p>
                </div>
                <div class="product-card-coupon-item-receive" v-if="item.hasFlag==0" @click="getCoupon(item.id)">领</div>
                <div class="product-card-coupon-item-receive" v-else>已<br>领</div>
              </div>
              <div class="product-card-coupon-more" v-if="examInfo.couponsList.length>2" @click="dialogFormVisible4 = true">更多 ></div>
            </div>
            <div class="product-card-enroll" v-if="type==1">
              <p class="product-card-enroll-moeny" v-if="examInfo.ifFree==0"><span>￥</span>{{examInfo.salePrice}}</p>
              <p class="product-card-enroll-originalPrice" v-if="examInfo.ifFree==0">￥{{examInfo.originPrice}}</p>
              <p class="product-card-enroll-moeny" v-else style="font-size: 18px;line-height: 18px;">免费</p>
              <el-button size="medium" type="warning" @click="auditStatus" style="padding: 12px 70px;background-color: #ff821c">立即报名</el-button>
              <div class="product-card-enroll-share" @click="dialogFormVisible5 = true">
                |
                <img src="../../assets/img/icon18.png">
                <p>分享</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="background-color: #F7F9FB; padding-top: 40px">
      <div class="main-con" >
        <div class="exam-contetn">
          <div style="flex: 1;" >
            <div class="exam-contetn-text">
              <div class="head">
                <div class="head-left"> 
                  <p class="title">考试介绍</p>
                  <p class="tiao"></p>
                </div>
              </div>
              <div v-html="examInfo.examDesc" class="exam-desc"></div>
            </div>
          </div>
    
          <div style=" width: 30%;" v-if="examInfo.courseList.length>0">
            <div class="exam-contetn-item" >
              <p class="exam-contetn-item-title">关联课程</p>
              <ul>
                <li v-for="item,index in examInfo.courseList" :key="index" @click="onCourseDetails(item.id)">
                  <img :src="item.courseImg">
                  <p>{{item.courseName}}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="popup">
      <!-- 报名 -->
      <el-dialog title="" :visible.sync="dialogFormVisible1">
        <p class="popup-title">填写报名表</p>
        <div class="popup-form">
          <el-form :label-position="labelPosition" label-width="80px" :model="userInfo" :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <el-form-item label="姓名：">
              <el-input v-model="userInfo.realName" placeholder="请输入真实姓名" disabled></el-input>
            </el-form-item>
            <el-form-item label="证件号：">
              <el-input v-model="userInfo.idCard" placeholder="请输入证件号" disabled></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱：">
              <el-input v-model="userInfo.email" placeholder="请输入电子邮箱" disabled></el-input>
            </el-form-item>
            <el-form-item label="手机号：">
              <el-input v-model="userInfo.mobile" placeholder="请输入手机号" disabled></el-input>
            </el-form-item>
            <el-form-item label="考试场次：" prop="startTime">
              <el-select v-model="userInfo.startTime" filterable placeholder="请选择考试场次" style="width: 100%" @change="onCollege">
                <el-option
                  style="font-size: 12px;"
                  v-for="item in collegeList"
                  :key="item.id"
                  :label="item.startTime"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <div class="checked">
              <el-checkbox size="mini" text-color="#ff821c" fill="#ff821c" v-model="checked">我已阅读</el-checkbox>
              <span class="checkbox-span" @click="commonText('ksyszc')">《海量数据学院考试规则及隐私政策》</span>
            </div>
            <el-form-item style="text-align: center;">
              <el-button style="background-color: #ff821c" size="small" type="warning" :loading="loading" @click="submitForm('ruleForm')">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>

      <!-- 支付 -->
      <el-dialog title="" :visible.sync="dialogFormVisible2">
        <p class="popup-title">支付</p>
        <div class="popup-form">
          <p class="popup-form-title"><span>*</span>{{ examInfo.examName }}</p>
          <p class="popup-form-moeny"><span>￥</span>{{examInfo.salePrice}}</p>
          
          <div class="popup-form-coupon" v-if="payCouponsList.length>0">
            <!-- @change="handleChange" v-model="activeNames" -->
            <el-collapse v-model="activeNames" accordion>
              <el-collapse-item title="请选择优惠券" :name="payCouponsList.length>0?'coupons':''" style="color: #a9a9a9;">
                <div class="product-card-coupon" style="display: block;">
                  <div class="product-card-coupon-item" v-if="item.hasFlag==1" v-for="item,index in payCouponsList" :key="index" @click="onCoupon(item.id,item.discountRatio)">
                    <p class="product-card-coupon-item-discount">{{ item.discountRatio *10 }}<span>折</span></p>
                    <div class="product-card-coupon-item-content">
                      <p class="product-card-coupon-item-content-name">{{item.couponName}}</p>
                      <p class="product-card-coupon-item-content-time">{{ item.createTime }}</p>
                    </div>
                    <div class="product-card-coupon-item-receive">
                      <img src="../../assets/img/icon3.png" v-if="item.checked">
                      <img src="../../assets/img/icon2.png" v-else>
                    </div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
          <ul>
              <li class="popup-way-item" v-for="item,index in wayItem" :key="index" @click="onChecked(index)">
                <div style="height:12px;">
                  <img v-if="payCur==index" class="popup-way-item-checked" src="../../assets/img/icon25.png">
                  <img v-else class="popup-way-item-checked" src="../../assets/img/icon26.png">
                </div>
                <img class="popup-way-item-wx" v-if="index==0" src="../../assets/img/wx.png">
                <img class="popup-way-item-wx" v-else-if="index==1" src="../../assets/img/zfb.png">
                <!-- <img class="popup-way-item-wx" v-else src="../../assets/img/yl.png"> -->
                <span class="popup-way-item-name">{{item.name}}</span>
              </li>
          </ul>
          <div style="display: flex;align-items: center;justify-content: space-between;">
            <el-button style="background-color: #ff821c" size="medium" type="warning" @click="onNextStep">下一步</el-button>
            <el-button class="buttons" size="medium" @click="dialogFormVisible2 = false">取消</el-button>
          </div>
        </div>
      </el-dialog>

      <!-- 报名不成功 -->
      <el-dialog title="" :visible.sync="dialogFormVisible3" >
        <p class="popup-title">温馨提示</p>
        <div class="popup-form" style="padding-bottom: 70px;">
          <p class="popup-form-title" style="border-bottom: none;padding-bottom: 4px;"><span>*</span>请先完成以下考试才可报名</p>
          <div class="popup-form-tips">
            <p class="popup-form-tips-text">{{examName}}</p>
            <p class="popup-form-tips-g"></p>
            <p class="popup-form-tips-type">未通过</p>
            <p class="popup-form-tips-g"></p>
            <p class="popup-form-tips-sub" @click="onExamPage">点击前往 ></p>
          </div>
          <div style="text-align: center;">
            <el-button  size="medium" type="warning" style="width: 40%;background-color: #ff821c" @click="dialogFormVisible3 = false">我知道了</el-button>
          </div>
        </div>
      </el-dialog>

      <!-- 更多优惠券 -->
      <el-dialog title="" :visible.sync="dialogFormVisible4">
        <p class="popup-title">更多优惠券</p>
        <div class="popup-form" style="padding:60px 110px 30px;">
          <div class="product-card-coupon popup-coupon">
            <div class="product-card-coupon-item popup-coupon-item" :class="item.hasFlag==0?'':'popup-coupon-cur'" v-for="item,index in examInfo.couponsList" :key="index" v-if="item.isShow ==1">
              <p class="product-card-coupon-item-discount">{{ item.discountRatio * 10}}<span>折</span></p>
              <div class="product-card-coupon-item-content">
                <p class="product-card-coupon-item-content-name">{{item.couponName}}</p>
                <p class="product-card-coupon-item-content-time">{{item.createTime}}</p>
              </div>
              <div class="product-card-coupon-item-receive" v-if="item.hasFlag==0" @click="getCoupon(item.id)">领</div>
              <div class="product-card-coupon-item-receive" v-else>已<br>领</div>
            </div>
          </div>
        </div>
      </el-dialog>

      <!-- 分享 -->
      <el-dialog title="" :visible.sync="dialogFormVisible5">
        <p class="popup-title">分享</p>
        <div class="popup-form" style="padding:60px 180px 80px;text-align: center">
          <qrcode :text="'https://education.vastdata.com.cn/mobile/#/pages/exam/details?id='+id+'&type=1'"></qrcode>
          <p class="popup-share-text">微信扫描二维码查看</p>
          <div class="popup-share-copy" @click="copyText">
            <p>复制链接</p>
            <img src="../../assets/img/icon33.png">
          </div>
        </div>
      </el-dialog>

      <el-dialog title="" :visible.sync="dialogFormVisible6">
        <p class="popup-title">微信支付</p>
        <div class="popup-form" style="padding:60px 180px 80px;text-align: center">
          <img class="popup-share-img" :src="examHtml">
          <p class="popup-share-text">微信扫描二维码支付</p>
          <el-button style="background-color: #ff821c" size="medium" type="warning" @click="getOrderInfo">我已支付</el-button>
        </div>
      </el-dialog>
    </div>

    <el-footer class="index-footer" style="height: auto; background-color: #f0f4f7;border-top: solid 1px #e6e6e6">
      <footers></footers>
    </el-footer>
  </el-container>
</template>
<script>
// 导入组件
import navcon from '../../components/navcon.vue'
import footers from '../../components/footers.vue'
import qrcode from '../../components/qrcode.vue'
import { examInfo, examSign,userInfo,lotList,examPay,getCoupon,orderInfo,editExamOrder } from '../../api/userMG'
export default {
  name: 'index',
  data() {
    return {
      id:'',
      type:1,
      examInfo:{},
      userInfo:{
        startTime:''
      },
      showclass: 'asideshow',
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      dialogFormVisible4: false,
      dialogFormVisible5: false,
      dialogFormVisible6: false,
      labelPosition: 'top',
     
      value: [],
  
      checked:false,
  
      couponChecked:false,
      loading:false,
      collegeList:[],
      rules: {
        startTime: [
          { required: true, message: '请选择考试场次', trigger: 'change' }
        ]
      },
      lotId:'',
      wayItem:[
        {
          name:'微信支付'
        },
        {
          name:'支付宝支付'
        },
        // {
        //   name:'企业银行转帐'
        // }
      ],
      payCur:0,
      orderId:'',
      loadingp:false,
      examName:'',
      examId:'',
      examHtml:'',
      status:0,
      discount:'',
      couponIds:'',
      discountRatio:-1,
      payCouponsList:[],
      activeNames:['coupons']
    }
  },

  // 注册组件
  components: {
    navcon,
    footers,
    qrcode
  },
  computed: {
    url() {
      return this.$store.getters.url;
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    this.discount = this.$route.query.discountId;
    this.getExamInfo();
  },

  methods:{
    onChecked(e){
      this.payCur = e;
    },
    auditStatus(){
      this.status = localStorage.getItem('auditStatus');
      let token =  localStorage.getItem('token')
      if(!token){
        this.$message({
          message: '请先登录！',
          type: 'warning',
          offset:100
        })
        setTimeout(() => {
          this.$router.push({path:'/login/login'})
        }, 2000);
      }else{
        this.getUserInfo();
        
      }
      
    },
    // 获取考试报名
    getExamInfo(){
      let params = {
        id:this.id,
        discount:this.discount
      }
      // const loading = this.$loading({
      //   lock: true,
      //   text: '加载中',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // });
      examInfo(params).then(res => {
        this.examInfo = res.data;
        let couponsList = []
        if(this.discount){
          let salePrice = res.data.salePrice * res.data.discount
          this.examInfo.salePrice = salePrice.toFixed(2)
        }
        // 调用支付的优惠券列表
        this.payCouponsList = res.data.couponsList;
        this.payCouponsList.forEach((item,i) => {
					item.checked = false;
				})

        
        res.data.couponsList.forEach((item,i) => {
          if(item.isShow==1){
            couponsList.push(item)
          }
				})
        this.examInfo.couponsList = couponsList;
        this.examInfo.couponsList.forEach((item,i) => {
					item.checked = false;
				})

      })

      // .catch(err => {
      //   loading.close();
      // })
    },

    // 获取考试轮次列表
    getLotList(){
      let params = {
        examId:this.id
      }
      lotList(params).then(res => {
        this.collegeList = res.data;
      })
      .catch(err => {
      })
    },

    // 领取优惠券
    getCoupon(id){
      let params = {
        couponId:id
      }
      const loading = this.$loading({
        lock: true,
        text: '领取中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      getCoupon(params).then(res => {
        if(res.code==0){
          this.$message({
            message: '领取成功！',
            type: 'success',
            offset:100
          })
          this.getExamInfo()
        }else{
          this.$message({
            message: res.msg,
            type: 'success',
            offset:100
          })
        }
        loading.close();
      })
      .catch(err => {
        loading.close();
      })
    },

    onCollege(id){
      this.lotId = id
    },

    // 获取个人信息
    getUserInfo(){
      userInfo().then(res => {
        this.userInfo = res.data;
        this.status = res.data.auditStatus;
        if(this.status==1){
          this.getLotList();
          this.dialogFormVisible1 = true;
        }else{
          this.$message({
            message: '请进行实名认证后再次操作！',
            type: 'warning',
            offset:100
          })
          setTimeout(() => {
            this.$router.push({path:'/personal/personal'})
          }, 2000);
        }
      })
      .catch(err => {
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(!this.checked){
            this.$message({
              message: '请阅读并勾选《海量数据学院考试规则及隐私政策》',
              type: 'warning',
              offset:100
            })
            return
          }
          let params = {
            examId:this.id,
            lotId:this.lotId,
            discount:this.discount
          }
          this.loading = true;
          examSign(params).then(res => {
            if(res.code==0){
              this.dialogFormVisible1 = false;
              if(this.examInfo.ifFree == 0){
                this.orderId = res.data.id;
                this.dialogFormVisible2 = true;
              }else{
                this.$message({
                  message: '报名成功',
                  type: 'success',
                  offset:100
                })
                setTimeout(() => {
                  this.$router.push({path:'/enroll/enroll'})
                }, 1500)
              }
              this.loading = false;
            }else if(res.code == 200){
              this.dialogFormVisible1 = false;
              this.dialogFormVisible3 = true;
              this.examName = res.data.examName;
              this.examId = res.data.id
              this.loading = false;
            }
          })
          .catch(err => {
            this.loading = false;
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    onCoupon(id,discountRatio){
      this.payCouponsList.forEach((item,i) =>{
        if(item.id == id){
          item.checked = !item.checked
          if(item.checked){
            this.couponChecked = true;
            this.couponIds = id;
            this.discountRatio = discountRatio;
          }else{
            this.couponChecked = false;
            this.discountRatio = -1;
          }
        }else{
          item.checked = false;
        }
      })
      this.$forceUpdate()
    },
    onNextStep(){
      console.log(this.couponChecked || this.discount)
      if(this.couponChecked || this.discount){
        this.editExamOrder()
      }else{
        this.submitCoupon()
      }
    },

    editExamOrder(){
      let params = {
        couponId:this.couponChecked?this.couponIds:'',
        orderId:this.orderId,
        discountId:this.discount
      }
      // return
      editExamOrder(params).then(res => {
        if(res.code==0){
          let salePrice = this.examInfo.salePrice;
          if(this.couponChecked){
            salePrice = this.examInfo.salePrice*this.discountRatio;
          }
          if(salePrice>0){
            this.submitCoupon()
          }else{
            this.$message({
              message: '支付成功',
              type: 'success',
              offset:100
            })
            setTimeout(() => {
              this.$router.push({path:'/enroll/enroll'})
            }, 1500)
          }
        }
      })
    },

    commonText(code){
      this.$router.push({path:'/login/text',query: { code: code }})
    },

    // 跳转支付
    submitCoupon(){
      let payType = this.payCur==0?3:6;
      if(payType==6){
        // 'de9e80378ebf4f6fbad0fedde1140626'
        // this.$router.push({path:'/pay/Order', query: { payType: 6,orderId:this.orderId}})
        window.open('#/pay/Orderz?payType=6&orderId='+this.orderId, '_blank');
        this.dialogFormVisible2 = false;
      }else{
        this.dialogFormVisible6 = true;
        let params = {
          payType:3,
          orderId:this.orderId
        }
        examPay(params).then(res => {
          console.log('支付',res);
          if(res.code==0){
            this.examHtml = res.data;
          }
        })
        .catch(err => {
        })
      }
    },
    getOrderInfo(){
      orderInfo({id:this.orderId}).then(res => {
        console.log('支付详情',res);
        let orderStatus = res.data.status;
        if(orderStatus==0){
          this.$message({
            message: '您还未支付',
            type: 'warning',
            offset:100
          })
        }else{
          location.reload()
        }
      })
    },
    
    onExamPage(){
      this.id = this.examId;
      this.type = 1;
      this.dialogFormVisible3 = false;
      this.getExamInfo();
      this.$forceUpdate()
    },
    copyText() {
      const input = document.createElement('input');
      input.value = 'https://education.vastdata.com.cn/mobile/#/pages/exam/details?id='+this.id+'&type=1'; // 获取要复制的文本
      document.body.appendChild(input);
      input.select(); // 选中文本
      document.execCommand('copy'); // 执行复制操作
      document.body.removeChild(input); // 移除临时的输入框
      this.$message({
        message: '链接已复制',
        type: 'success',
        offset:100
      })
    },
    onCourseDetails(id){
      this.$router.push({path:'/index/classroomDetails', query: { id: id, type:1 }})
    }
  }
}
</script>
<style scoped>
  .banner{
    width: 100%;
    height: 400px;
  }
  .banner img{
    width: 100%;
    height: 100%;
  }
  @media (min-width: 1366px) {
    .main-con { 
        width: 1000px;
      }
    }
  @media (min-width: 1600px) {
    .main-con {
      width: 1300px;
    }
  }

  .main-con {
    margin: auto;
    padding-bottom: 40px;
  }
  .index-con {
    height: 100%;
    box-sizing: border-box;
    margin: auto;
  }
  
  .aside {
    width: 64px !important;
    height: 100%;
    background-color: #334157;
    margin: 0px;
  }
  .asideshow {
    width: 240px !important;
    height: 100%;
    margin: 0px;
  }
  .index-main{
    margin-left: 20px !important;
  }
  .index-header,
  .index-main,
  .index-footer {
    padding: 0px;
    height: auto;
    margin: 0; 
  }

  .authentication{
    display: flex;
    align-items: center;
    /* justify-content: space-between; */
    margin-top: 10px;
  }
  .product-image{
    width: 42%;
    margin-right: 30px;
    border-radius: 4px;
  }
  .product-card{
    flex: 1;
  }
  .product-card-name{
    font-size: 18px;
    color:black;
    margin-bottom: 10px;
  }
  .product-card-time{
    font-size: 12px;
    color: #9b9b9b;
    margin-bottom: 10px;
  }
  .product-card-kv{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 10px;
    border-radius: 6px;
    margin-bottom: 10px;
    background: #fff7f1;
  }
  .product-card-kv .key{
    width: 33%;
    font-size: 13px;
    padding: 6px 0;
    background: url('../../assets/img/icon1.png') left center/10px 10px no-repeat;
    padding-left: 14px;
    color: #8f8f8f;
  }
  .product-card-kv .key span{
    font-size: 13px;
    color: black;
  }
  .product-card-coupon{
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
  .product-card-coupon-item{
    width: 44%;
    height: 50px;
    border: 1px solid #ffe2ca;
    display: flex;
    align-items: center;
    margin-right: 8px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .product-card-coupon-item-discount{
    width: 54px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: linear-gradient(bottom,#ff6f19,#ff8c15);
    font-size: 22px;
    color: #fff;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    margin-right: 10px;
  }
  .product-card-coupon-item-discount span{
    font-size: 12px;
  }
  .product-card-coupon-item-content{
    width: 61%;
  }
  .product-card-coupon-item-content-name{
    font-size: 12px;
    color: #f26212;
    margin-bottom: 8px;
    line-height: 12px;
  }
  .product-card-coupon-item-content-time{
    font-size: 10px;
    color: #a1a1a1;
    line-height: 10px;
  }
  .product-card-coupon-item-receive{
    width: 20px;
    height: 100%;
    border-left: 1px dotted #ffe4cd;
    font-size: 14px;
    color: #f26212;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    background: #fff3eb;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    cursor: pointer;
  }
  .product-card-coupon-more{
    width: 56px;
    height: 50px;
    background: #f5f5f5;
    color: #b9b9b9;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    cursor: pointer;
  }
  .product-card-enroll{
    display: flex;
    align-items: center;
  }
  .product-card-enroll-moeny{
    font-size: 30px;
    color: #f25801;
    margin-right: 20px;
  }
  .product-card-enroll-moeny span{
    font-size: 15px;
  }
  .product-card-enroll-originalPrice{
    text-decoration: line-through;
    font-size: 14px;
    color: #a0a0a0;
    margin-right: 40px;
  }
  .product-card-enroll-share{
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    color: #e6e6e6;
    cursor: pointer;
  }
  .product-card-enroll-share img{
    width: 13px;
    height: 13px;
    margin: 0 10px 0 16px;
  }
  .product-card-enroll-share p{
    font-size: 13px;
    color: #babbbe;
  }

  .exam-contetn{
    display: flex;
  }
  .exam-contetn-text{
    background: #fff;
    padding: 30px;
    border-radius: 8px;
  }
  .head{
    display: flex;
    justify-content: space-between;
    border-bottom: solid 1px #e6e6e6;
    width: 100%;
    margin-bottom: 30px;
  }
 
  .title{
    font-size: 16px;
    font-weight: 500;
    color: black;
    letter-spacing: 1px;
    margin-bottom: 6px;
  }
  .tiao{
    height: 3px;
    background: #fe6a00;
    border-radius: 4px;
  }
  .exam-contetn-item{
    background: #fff;
    padding: 30px 16px 20px;
    border-radius: 8px;
    margin-left: 30px;
  }
  .exam-contetn-item-title{
    font-size: 14px;
    color: black;
    border-left: 3px solid #f25801;
    padding-left: 10px;
    line-height: 14px;
    font-weight: 600;
    margin-bottom: 10px;
  }
  .exam-contetn-item ul li{
    border-top: 1px solid #f1f1f1;
    margin-bottom: 15px;
    padding: 14px 0 4px;
    cursor: pointer;
  }
  .exam-contetn-item ul li img{
    width: 100%;
    border-radius: 8px;
    margin-bottom: 10px;
  }
  .exam-contetn-item ul li p{
    font-size: 13px;
    color: black;
  }

  .popup /deep/ .el-dialog__header, .popup /deep/ .el-dialog__body{
    padding: 0;
  }
  .popup /deep/ .el-dialog__headerbtn .el-dialog__close{
    color: #fff;
    font-size: 19px;
  }
  .popup /deep/ .el-dialog{
    border-radius: 8px;
  }
  .popup /deep/ .el-form-item__label{
    color: #000;
    font-weight: 600;
  }
  .popup-title{
    background: #ff821e;
    color: #fff;
    font-size: 16px;
    padding: 20px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  .popup-form{
    padding: 40px 110px;
  }
  .el-button--small{
    padding: 10px 80px;
  }
  .el-checkbox__label{
  font-size: 10px;
  }
.checked{
  margin-bottom: 30px;
}
.checked span{
  font-size: 10px;
  color: #adadad;
}
.checked .checkbox-span{
  color: #adadad;
  cursor: pointer;
}
.checked /deep/ .el-checkbox__label{
  color: #999 !important;
  font-size: 10px;
  padding-left: 6px;
}
.el-checkbox__input.is-checked+.el-checkbox__label{
  color: #adadad;
}
.checked /deep/ .is-checked .el-checkbox__inner{
  background-color: #adadad;
}
.checked /deep/ .el-checkbox__inner{
  width: 12px;
  height: 12px;
  border: 1px solid #adadad;
  margin-top: 2px;
}
.el-checkbox__input.is-checked .el-checkbox__inner{
  background-color: #adadad;
  color: #adadad;
  border: 1px solid #adadad;
}
.el-checkbox__input.is-focusel-checkbox_immer{
  border: 1px solid #adadad;
}
.popup-form-title{
  font-size: 14px;
  color: black;
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 20px;
  margin-bottom: 20px;
}
.popup-form-title span{
  font-size: 15px;
  color: #f25902;
  margin-right: 2px;
}
.popup-form-moeny{
  font-size: 30px;
  color: #f25902;
  text-align: center;
  margin-bottom: 30px;
}
.popup-form-moeny span{
  font-size: 15px;
  color: #f25902;
}
.popup-form-coupon{
  margin-bottom: 20px;
}
.el-collapse-item__header{
  padding-left:10px;
  border-left: 1px solid #EBEEF5;
  border-right: 1px solid #EBEEF5;
}
.el-collapse-item__header.is-active,.el-collapse-item__header, .el-collapse-item__wrap{
  color: #a9a9a9;
  border-bottom: 1px solid #EBEEF5;
}
.popup-form-coupon .product-card-coupon{
  padding: 14px 2px 1px;
  box-shadow: 0 0 10px rgba(222, 207, 207, 0.5);
  margin: 10px 0;
}
.popup-form-coupon .product-card-coupon-item{
  width: 100%;
  margin-bottom: 12px;
  border-radius: 4px;
  cursor: pointer;
}
.popup-form-coupon .product-card-coupon-item-content{
  width: 78%;
}
.popup-form-coupon .product-card-coupon-item-receive{
  background: none;
  border-left: none;
}
.popup-form-coupon .product-card-coupon-item-receive img{
  width: 20px;
  height: 20px;
}
.el-button--medium{
  width: 48%;
  padding: 14px 20px;
}
.popup-form-tips{
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f0f4f7;
  border-radius: 8px;
  padding: 22px 20px;
  margin-bottom: 60px;
}
.popup-form-tips-text,.popup-form-tips-type{
  font-size: 14px;
  color: #727373;
}
.popup-form-tips-sub{
  font-size: 14px;
  color: #f25902;
  cursor: pointer;
}
.popup-form-tips-g{
  width: 1px;
  height: 30px;
  background: #dfe3e6;
}

.popup-coupon{
  flex-wrap: wrap;
  justify-content: space-between;
}
.popup-coupon-item{
  width: 48%;
  margin:0 0 30px;
}
.popup-coupon-cur{
  border: 1px solid #eeeeee;
}
.popup-coupon-cur .product-card-coupon-item-discount{
  background-image: linear-gradient(bottom,#b0b4b5,#dedfdb);
}
.popup-coupon-cur .product-card-coupon-item-content-name, .popup-coupon-cur .product-card-coupon-item-receive{
  color: #a1a1a1;
}
.popup-coupon-cur .product-card-coupon-item-receive{
  background: #f9f9f9;
}
.popup-coupon-cur .product-card-coupon-item-content{
  width: 63%;
}

.popup-share-img{
  width: 200px;
  height: 200px;
  margin-bottom: 26px;
}
.popup-share-text{
  font-size: 15px;
  color: black;
  text-align: center;
  border-bottom: 2px dotted  #ebebeb;
  padding-bottom: 20px;
}
.popup-share-copy{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  cursor: pointer;
}
.popup-share-copy p{
  font-size: 13px;
  color: #999999;
  margin-right: 4px;
  line-height: 13px;
}
.popup-share-copy img{
  width: 16px;
  height: 16px
}
.exam-desc /deep/ img{
  width: 100%;
}
  .popup-form ul{
    display: flex;
    align-items:center;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  .popup-way-item{
    display: flex;
    align-items:center;
    justify-content: center;
    border: 1px solid #E6E6E6;
    width: 48.5%;
    height: 70px;
    cursor: pointer;
  }
  .popup-way-item-checked{
    width: 12px;
  }
  .popup-way-item-wx{
    width: 22px;
    margin: 0 12px;
  }
  .popup-way-item-name{
    font-family: SourceHanSansCN;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    line-height: 14px;
  }
  .popup /deep/ .el-dialog__wrapper{
    /* z-index: 9999 !important; */
  }
  .index-con /deep/ .el-select-dropdown{
    /* z-index: 20008 !important; */
  }
</style>



// WEBPACK FOOTER //
// src/views/index/examDetails.vue